export enum EErrorTypes {
  ACCOUNT_EXISTS = "auth/account-exists-with-different-credential",
}

export type ErrorTypes = EErrorTypes.ACCOUNT_EXISTS;
